var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-5 onboarding"},[_c('section',{staticClass:"onboarding-header"},[_c('ConfigInformation',{attrs:{"app":_vm.app}})],1),_c('section',{staticClass:"onboarding-content"},[_c('prestashop-accounts')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }